export const MOST_RECENT_CROSSWORD_DATE = new Date("2016-05-01");
export const LEAST_RECENT_CROSSWORD_DATE = new Date("1978/03/20");
export const INITIAL_CROSSWORD_DATE = new Date("2015-08-01");
export const API_URL_BASE = process.env.REACT_APP_API_URL_BASE || "";
export const APP_VER = process.env.REACT_APP_GIT_SHA || "<develop>";
